import { GridRenderCellParams } from '@mui/x-data-grid';

const tourBookingNumbersFormatter = ({ row }: GridRenderCellParams<App.Order>) => {
  return row.tour_items.map((item) => item.booking_number).join(', ');
};

export default tourBookingNumbersFormatter;
